import ChatThread from '@pdcfrontendui/components/ChatThread';
import { type Message } from '@pdcfrontendui/components/ChatMessage';
import Header from '@pdcfrontendui/components/Header';
import Icons, { IconSize } from '@pdcfrontendui/components/Icons';
import React from 'react';
import { useIsDualView } from '@pdcfrontendui/hooks';
import { currentLanguage } from '../currentLanguage';
import scss from './Chat.module.scss';
import ids from '../testing/ids';
import { SlideIn } from '../components/SlideIn';
import { useFormatter } from '../hooks/useLang';
import {
  InlineNotification,
  NotificationType,
} from '@pdcfrontendui/components';

export default function Chat({
  title,
  messages,
  sendMessage,
  goBack,
  show,
  noSlideInOnDesktop,
  currentDay,
  isChatPage,
  canSeeConfidentialInfo = false,
}: {
  title: string;
  messages: Message[];
  sendMessage: (message: string) => void;
  goBack?: () => void;
  show: boolean;
  noSlideInOnDesktop?: boolean;
  currentDay: Date;
  canSeeConfidentialInfo?: boolean;
  isChatPage: boolean;
}) {
  const formatter = useFormatter();
  const isMobile = !useIsDualView();

  const inner = show && (
    <>
      {/* centerize only needed if button is shown */}
      <Header centerize={!!goBack}>
        {!isMobile &&
          ((!canSeeConfidentialInfo && !isChatPage) ||
            canSeeConfidentialInfo) && <Header.Spacer />}
        {goBack && (
          <Header.Left>
            <Icons.ChevronLeft
              onClick={goBack}
              id={ids.ShiftView.closeChat}
              size={IconSize.XSmall}
            />
          </Header.Left>
        )}
        <Header.Title bold={isMobile}>{title}</Header.Title>
      </Header>
      <ChatThread
        messages={messages}
        sendMessage={sendMessage}
        placeholder={currentLanguage.WriteMessage}
        inputId={ids.ShiftView.messageInput}
        sendButtonId={ids.ShiftView.sendMessage}
        maxLength={800}
        maxLengthError={currentLanguage.MaxLengthError}
        sendButtonAriaLabel={currentLanguage.SendMessage}
        unreadMessagesText={currentLanguage.UnreadMessages}
        formatTimestamp={(timestamp) =>
          formatter.shortInexact(timestamp, currentDay)
        }
      >
        {!canSeeConfidentialInfo && (
          <InlineNotification
            type={NotificationType.Info}
            className={scss.notification}
            header={currentLanguage.limitedAccess}
          >
            {currentLanguage.limitedAccessDescription}
          </InlineNotification>
        )}
      </ChatThread>
    </>
  );
  if (noSlideInOnDesktop && !isMobile) {
    return inner;
  }
  return (
    <SlideIn className={scss.comp} id={ids.ShiftView.chatThread} absolute>
      {inner}
    </SlideIn>
  );
}
